export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mp3-mediarecorder.worker.a8dd58945ffc6028f6cf.worker.js");
}
